var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 720.161,
    height: 497.591,
    viewBox: "0 0 720.161 497.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 59.554,
    height: 63.647,
    transform: "translate(212.497 265.647)",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M26.246,364.33c47.847-40.919,99.988-7.454,219.286-105.81,0,.007,2.271-3.31,6.985-1.564l49.933-42.251c-3.1-5.39,10.638-24.151,30.032-37.362,0,0-1.4-9.429,12.22-6.635,0,0,1.047-16.063,19.554-18.158,0,0,.174-9.079,16.411-8.031,11.274-28.213,61.935-23.408,85.551.354,33.305,22.313,21.422,38.761,44.342,44.693,84.225-2.621,175.744-177.043,189.954,2.092,6.321,36.986,5.213,45.4,8.393,103.709,8.244-1.722,4.868,29.721,3.481,30.03,0,0,6.115-2.969,8.035,11.522s5.587,30.03,5.587,30.03c10.822,22.134-20.631,43.14-49.235,52.376-43.841,20.464-121.96,26.231-157.483,41.55-46.308,18.918-162.845,91.845-219.634,67.4C250.277,552.428-70.965,453.046,26.246,364.33",
    transform: "translate(-8.033 -110.904)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M116.649,491.877c18.639-11.09,37.771-23.377,57.186-37.005A913.748,913.748,0,0,0,324.346,322.185l-27.021,4.606c-35.891,22.9-76.645,46.766-122.2,70.18-45.313,23.291-88.231,42.465-127.576,58.28a248.313,248.313,0,0,0,69.1,36.626",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M324.346,322.185s-133.47,27.9-108.852-18.6,34.541-42.491,56.558-28.61c0,0,53.112,23.864,60.521,29.15s-8.227,18.061-8.227,18.061",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M360.079,608.495l58.646-43.565c-14.6-30.289-28.958-62.433-42.761-96.431-20.655-50.876-37.623-99.892-51.618-146.313l-17.47,18.8a675.068,675.068,0,0,0,6.788,102.574,651.179,651.179,0,0,0,46.415,164.937",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M479.263,453.694A167.355,167.355,0,0,0,434.8,374.57c-40.687-40.521-91.514-49.837-110.457-52.384l23.879-12.08,43.474-2.815c7.392,5.845,14.791,12.137,22.125,18.912a377.466,377.466,0,0,1,85.547,117.319Z",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M485.293,162.937s-94.781,52.61-116.17,88.627l76.033,3.65s66.039-60.559,86.97-58.982Z",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M348.226,310.106s-7.465-49.081,20.9-58.542,114.28-15.914,80.954,19.618,20.187,38.346-101.851,38.924",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff37be"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M318.032,329.086c6.044,8.259,27.781,8.508,39.76-1.828,5.357-4.622,7.1-9.928,10.317-19.707,1.731-5.266,4.934-15.008.6-18.06a6.829,6.829,0,0,0-4.435-.888c-30.519,2.2-45.778,3.3-49.792,11.978-1.113,2.407-.382,7.464,1.083,17.576.908,6.28,1.363,9.42,2.468,10.929",
    transform: "translate(-8.033 -110.904)",
    fill: "#ff69d5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-8.033 -110.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M231.566,328.857c-6.78,2.078-16.019-3.523-18.39-10.925-1.357-4.236-.726-8.6,2.319-14.348,24.618-46.505,34.54-42.49,56.556-28.609a94.39,94.39,0,0,0-24.245,26.685c-8.557,14.463-8.719,24.892-16.24,27.2",
    fill: "#912277"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.9c2c1882b332bc2e15fd233d32c4a369.svg";
export { ForwardRef as ReactComponent };